import React, { Component } from 'react';
import classNames from 'classnames/bind';

import { Tabs, TabLink, TabPane } from '@marvelapp/marvel-ui/tabs';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import ArrowRight from 'marketing-website/components/icons/ArrowRight';

import tabs from 'marketing-website/configs/pages/homepage/tabs';
import generalStyles from './style/powerful-design.module.css';

const cx = classNames.bind({ ...generalStyles });

export default class PowerfulDesignDesktop extends Component {
  constructor() {
    super();

    this.state = {
      selectedTab: 'tab0',
    };

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  render() {
    const { selectedTab } = this.state;

    return (
      <div className={generalStyles.container}>
        <Tabs
          handleSelect={this.handleSelect}
          selectedTab={selectedTab}
          isVertical
          sidebarSize="medium"
        >
          {tabs.map((item, index) => {
            const tab = `tab${index}`;
            const isSelected = selectedTab === tab;
            const headingColor = isSelected ? 'blue' : 'black';
            const arrowClassName = cx('arrow', {
              arrowActive: isSelected,
            });

            return (
              <TabLink key={item.id} to={tab}>
                <Spacing size="xxs" position="topBottom" type="padding">
                  <Spacing size="xs" position="bottom" type="margin">
                    <div className={cx('titleContainer')}>
                      <div className={arrowClassName}>
                        <ArrowRight />
                      </div>
                      <Heading tag="h3" size="l" weight="semibold">
                        <div className={`c-${headingColor}`}>{item.title}</div>
                      </Heading>
                    </div>
                  </Spacing>
                  <MaxWidth value={210}>
                    <Paragraph size="m" color="slate">
                      {item.subtitle}
                    </Paragraph>
                  </MaxWidth>
                </Spacing>
              </TabLink>
            );
          })}
          {tabs.map((item, index) => (
            <TabPane key={item.id} for={`tab${index}`}>
              <div className={generalStyles.imageContainer}>
                <Image {...item} hasShadow={false} />
              </div>
            </TabPane>
          ))}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/PowerfulDesign/PowerfulDesignDesktop.js